if (!customElements.get('new-sticky-atc')) {
  customElements.whenDefined('product-form').then(() => {
    class NewStickyAtc extends customElements.get('product-form') {
      constructor() {
        super();
        this.section = this.closest('.section-main-product');
        this.buyButtonsReference = this.section?.querySelector('.new-buy-buttons');
        this.bundle = this.querySelector('[data-new-sticky-bundle]');
        this.color = this.querySelector('[data-new-sticky-color]');
        this.separator = this.querySelector('.new-sticky-atc__separator');
        this.price = this.querySelector('[data-new-sticky-price]');
        this.quantityInput = this.form?.querySelector('[name="quantity"]');
        this.forceVisible = false;
        this.buyButtonsVisible = false;
        this.onBundleModalToggle = (event) => {
          this.forceVisible = Boolean(event.detail?.open);
          this.updateVisibility();
        };
        this.onBuyTotalUpdate = (event) => {
          const quantity = Math.max(1, Number(event.detail?.quantity) || 1);
          if (this.quantityInput) this.quantityInput.value = quantity;
          if (this.price && event.detail?.totalPrice) this.price.textContent = event.detail.totalPrice;
        };

        if (this.buyButtonsReference) {
          this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              this.buyButtonsVisible = entry.isIntersecting;
              this.updateVisibility();
            });
          });
          this.observer.observe(this.buyButtonsReference);
        }
        document.addEventListener('new-bundle-modal:toggle', this.onBundleModalToggle);
        this.section?.addEventListener('new-buy-buttons:total-updated', this.onBuyTotalUpdate);
        this.section?.addEventListener('on:variant:change', this.onVariantChange.bind(this));

        const buyQuantity = this.section?.querySelector('[data-new-buy-quantity-input]');
        const buyTotalPrice = this.section?.querySelector('[data-new-buy-total-price]');
        this.onBuyTotalUpdate({
          detail: {
            quantity: buyQuantity?.value,
            totalPrice: buyTotalPrice?.textContent
          }
        });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        document.removeEventListener('new-bundle-modal:toggle', this.onBundleModalToggle);
        this.section?.removeEventListener('new-buy-buttons:total-updated', this.onBuyTotalUpdate);
      }

      updateVisibility() {
        this.classList.toggle('new-sticky-atc--out', !this.forceVisible && this.buyButtonsVisible);
      }

      onVariantChange(event) {
        const { variant } = event.detail;
        if (!variant) return;
        const picker = event.target;
        const bundle = picker.querySelector('.new-variant-picker__selector--bundle input:checked')?.value || variant.option1;
        const color = picker.querySelector('.new-variant-picker__selector--color input:checked')?.value || variant.option2;
        const formattedPrice = picker.data?.formatted?.[variant.id]?.price;

        if (this.bundle) this.bundle.textContent = bundle || '';
        if (this.color) {
          this.color.textContent = color || '';
          this.color.hidden = !color;
        }
        if (this.separator) this.separator.hidden = !color;
        if (this.price && !this.section?.querySelector('[data-new-buy-total-price]')) {
          this.price.textContent = formattedPrice || new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(variant.price / 100);
        }
        const idInput = this.form?.querySelector('[name="id"]');
        if (idInput) idInput.value = variant.id;

        if (this.submitBtn) {
          this.submitBtn.disabled = !variant.available;
          this.submitBtn.textContent = variant.available ? this.submitBtn.dataset.addToCartText : this.submitBtn.dataset.unavailableText;
        }
      }
    }

    customElements.define('new-sticky-atc', NewStickyAtc);
  });
}
